import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { getAmenityIcon } from '../getIcon';

import type { HotelAmenityItem } from '@shared/types/hotel-content';

import STYLES from './MainAmenities.module.scss';

const cls = cssModules(STYLES);

const MainAmenities = ({
  mainAmenities,
}: {
  mainAmenities: HotelAmenityItem[];
}) => (
  <div className={cls('MainAmenities')}>
    {mainAmenities.map((mainAmenity) => {
      const { displayName, type } = mainAmenity;
      const Icon = getAmenityIcon(type);

      return (
        <div key={type} className={cls('MainAmenities__amenity')}>
          <div className={cls('MainAmenities__amenityContent')}>
            <span className={cls('MainAmenities__amenityIcon')}>
              <Icon />
            </span>
            <BpkText
              textStyle={TEXT_STYLES.footnote}
              className={cls('MainAmenities__amenityName')}
            >
              {displayName}
            </BpkText>
          </div>
        </div>
      );
    })}
  </div>
);

export default MainAmenities;
